import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog"

export const WorkflowStepInputOutput = ({
  title,
  description
}: {
  title: string,
  description: string
}) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button
        className={`text-accent font-medium underline mr-3 disabled:text-popover 
          disabled:cursor-not-allowed`
        }
      >
        View Details
      </button>
    </AlertDialogTrigger>
    <AlertDialogContent className="max-w-3xl">
      <AlertDialogHeader>
        <AlertDialogTitle className="mb-6">
          <div className="flex flex-row items-center justify-between">
            <h3 className="">{title}</h3>
            <AlertDialogFooter>
              <AlertDialogCancel>Close</AlertDialogCancel>
            </AlertDialogFooter>
          </div>
        </AlertDialogTitle>
      </AlertDialogHeader>
      <div className="maximum-modal-component-height bg-foreground overflow-y-auto thin-scrollbar px-2 rounded-lg">
        <pre className="text-sm text-primary text-left p-2  w-inherit">
          {JSON.stringify(JSON.parse(description), null, 2)}
        </pre>
      </div>
    </AlertDialogContent>
  </AlertDialog>
)
